import { CLOUD_NEW_FEATURES_CONFIG } from 'reactApp/appHelpers/configHelpers';
import { CloudNewFeatures } from 'reactApp/ui/CloudNewFeatures/CloudNewFeatures';
import type { ToolbarItem, TToolbarItem } from 'reactApp/ui/Toolbar/Toolbar.types';

export const getNewFeaturesItem = (): TToolbarItem => {
    return {
        Item: CLOUD_NEW_FEATURES_CONFIG?.length ? (CloudNewFeatures as ToolbarItem) : null,
    };
};
